import { useState, useEffect } from 'react';

export const useDebouncedValue = <T>(input: T, delay: number) => {
  const [output, setOutput] = useState(input);

  useEffect(() => {
    const handle = setTimeout(() => {
      setOutput(input);
    }, delay);

    return () => clearTimeout(handle);
  }, [input, delay]);

  return output;
};
